import React from 'react'
import { Link } from 'react-router-dom'
import { isToday, format } from 'date-fns'
import { Select } from 'components/common'
import user, { User } from './user'


class Editor extends React.Component {
	constructor(props) {
		super(props);
		this.editor = React.createRef();
	}

	componentDidMount() {
		const editor = this.editor.current;

		editor.addEventListener("input", e => {
			this.props.model[this.props.name] = editor.innerText;
			if (this.props.onInput) {
				this.props.onInput(e);
			}
			this.forceUpdate();
		})
		editor.addEventListener("keydown", e => {
			if (e.ctrlKey || e.shiftKey) {
				return;
			}
			switch(e.keyCode) {
				case 13: // enter
					e.preventDefault();
					this.onSend();
					break;
				case 38: // seta cima
					if (this.props.onSelect && !this.props.model[this.props.name]) {
						this.props.onSelect();
					}
					break;
				case 27: // escape
				if (this.props.onSelect && this.props.model[this.props.name]) {
					this.props.onSelect(true);
				}
			}
		})
		editor.focus()
	}

	componentDidUpdate() {
		const editor = this.editor.current;
		const {model, name} = this.props;

		if (document.activeElement !== editor) {
			editor.innerText = model[name];
			return;
		}
		const selection = window.getSelection();
		const position = selection && selection.rangeCount > 0 ? selection.getRangeAt(0).startOffset : null;

		editor.innerText = model[name];

		if (editor.childNodes.length > 0 && position) {
			const range = document.createRange();
			range.setStart(editor.childNodes[0], position > editor.innerText.length ? editor.innerText.length : position);
			range.collapse(true);
			selection.removeAllRanges();
			selection.addRange(range);
		}
	}

	onSend() {
		if (!this.props.model[this.props.name]) {
			return;
		}
		this.props.model[this.props.name] = this.props.model[this.props.name].trim();
		if (this.props.model[this.props.name]) {
			this.props.onSend();
		}
	}

	render() {
		const {model, name} = this.props;

		return (
			<div className="input-group">
				<div className="input-group-append">
					<span className="input-group-text btn-pre">
						<em className="la la-pencil" />
					</span>
				</div>
				<span
					role="textbox"
					ref={this.editor}
					className="textarea"
					contentEditable={true}
					suppressContentEditableWarning={true}
				/>
				<div className="input-group-append" title={__('socials_chat_send_title')}>
					<button
						className={classNames("btn btn-send", model[name] == '' ? 'input-group-text' : 'btn-primary')}
						onClick={this.onSend.bind(this)}
					>
						<em className="la la-paper-plane" />
					</button>
				</div>
			</div>
		);
	}
}

export default class Chat extends React.Component {
	constructor(props) {
		super(props);
		//const active = props.to ? user.get(props.to) : null;
		this.state = {
			msg: {comment: ""}, // representa a nova mensagem a ser enviada
		}
		/*
		const chat = hp.store.chat || (hp.store.chat = 
			hp.store.chat = {
				until: null,
				data: {},
				users: {},
				unread: {} // guarda, por user, o numero de mensagens não lidas
			}
		);
		*/
		this.formatToday = "'" + __('date_today').toLowerCase() + ",' H:s";
		this.avatar = <em className="la la-user avatar" />;
		this.my_avatar =
			<div className="avatar">
				{user.main.profile.logo ? <img src={user.main.profile.logo} alt="" /> : this.avatar}
			</div>
		//this.read_timeout = 0;
		this.messages = React.createRef();
		this.socket = hp.store.chatSocket ? hp.store.chatSocket.socket : null;
		this.componentWillReceiveProps(props)
	}

	componentWillReceiveProps(props) {
		const chat = hp.store.chat;

		this.state.active = props.to || this.state.active || 0;
		if (!chat || !props.to) {
			return;
		}
		const chat_usr = chat.users[props.to];
		const usr = user.get(props.to);

		if (!chat_usr && usr) {
			chat.users[props.to] = usr.profile;
			chat.data[props.to] = [];
		}
		else if (chat.unread[props.to] > 0) {
			hp.store.chatSocket.setUnread(props.to);
		}
	}

	componentDidMount() {
		if (hp.store.chatSocket) {
			this.new_msg_handler = hp.store.chatSocket.subscribe('new-message', () => {
				this.active_prev = null;
				this.forceUpdate()
				if (this.state.active && hp.store.chat.unread[this.state.active] > 0) {
					hp.store.chatSocket.setUnread(this.state.active);
				}
			})
			this.typing_handler = hp.store.chatSocket.subscribe('typing', data => this.forceUpdate() )
		}
	}

	componentWillUnmount() {
		if (hp.store.chatSocket) {
			hp.store.chatSocket.unsubscribe('new-message', this.new_msg_handler);
			hp.store.chatSocket.unsubscribe('typing', this.typing_handler);
		}
	}

	componentDidUpdate() {
		// faz scroll apenas quando se muda de user
		if (this.messages.current && this.state.active && this.active_prev != this.state.active) {
			this.messages.current.scrollTop = this.messages.current.scrollHeight;
			this.active_prev = this.state.active;
		}
	}

	/*
	componentWillUpdate() {
		if (this.observer) {
			this.observer.disconnect()
		}
	}
	*/

	onInput(e) {
		if (!this.typing) {
			this.previousActive = this.state.active;
			this.typing = true;
			this.socket.emit('typing', {to: this.state.active});
		}
		this.last_typing_time = Date.now();
		setTimeout(() => {
			if ((Date.now() - this.last_typing_time) >= 1000 && this.typing) {
				this.typing = false;
				this.socket.emit('stop-typing', {to: this.previousActive});
			}
		}, 1000);
		const {active, msg} = this.state;

		if (!msg.comment && msg.id) {
			this.onCommentEdit(null, true);
		}
	}

	onSend() {
		const {active, msg} = this.state;

		if (!msg || !msg.comment) {
			return;
		}
		const {chat} = hp.store;
		const data = {
			comment: msg.comment,
			to: active,
			since: chat.until
		}
		if (msg.id) {
			data.id = msg.id;
			this.state.msg_org.comment = msg.comment;
		}
		hp.store.chatSocket.send(data).then(response => {
			this.active_prev = null;
			this.forceUpdate();
		});
		/*
		http.post('/home/chatSend.json', data, response => {
			// tell server to execute 'new message' and send along one parameter
			this.socket.emit('new-message', data);
			this.mergeResults(response);
			this.forceUpdate();
		})
		*/
		this.active_prev = null;
		this.setState({msg: {comment: ""}});
	}

	onSelectUser(uid) {
		this.setState({
			active: uid,
			msg: this.state.msg && this.state.msg.id ? {comment: ""} : this.state.msg,
			msg_org: null
		}, () => {
			hp.store.chatSocket.setUnread(uid);
		});
		/*
		const {chat} = hp.store;

		this.setState({
			active: uid,
			msg: this.state.msg && this.state.msg.id ? {comment: ""} : this.state.msg,
			msg_org: null
		});
		if (this.read_timeout) {
			clearTimeout(this.read_timeout);
		}
		// definir todas as mensagens deste user como lidas
		if (chat.unread[uid] > 0) {
			this.read_timeout = setTimeout(() => {
				http.post('/home/setChatRead.json', {to: uid, silent: true}, response => {
					this.read_timeout = 0;
					delete chat.unread[uid];
					// definir todas as mensagens como lidas
					const user_msgs = chat.data[uid] || {};
					Object.keys(user_msgs).forEach(id => {
						user_msgs[id].read = 1
					});
					this.forceUpdate();
				});
			}, 1000);
		}
		*/
	}

	onUserFound(selected) {
		const {chat} = hp.store;
		const {value} = selected;

		// verificamoa se o user já existe na lista
		if (!chat.users.hasOwnProperty(value)) {
			http.post('/home/getUser.json', {uid: value}, response => {
			if (Object.keys(response.users).length > 0) {
					User.merge(response.users);
					chat.users[value] = user.get(value).profile;
					this.setState({active: value});
				}
			});
			return;
		}
		this.setState({active: value});
	}

	onCommentEdit(msg, clear) {
		if (clear) {
			this.setState({
				msg: {comment: ""},
				msg_org: null
			});
		}
		else if (msg) {
			this.setState({
				msg: {id: msg.id, comment: msg.comment},
				msg_org: msg
			});
		}
	}

	onLockUser(usr, locked) {
		http.post('/home/lockChatUser.json', {
			data: {uid: usr.id, locked: locked},
			silent: true
		}, (response, success) => {
			if (success) {
				usr.chat_locking = locked;
			}
			this.forceUpdate();
		})
	}

	renderUserActions(usr) {
		const actions = [];

		if (usr.chat_locked == 1) {
			actions.push(
				<div key="x" className="dropdown-header">
					<em className="la la-lock" />
					<span>{__('socials_user_has_locked')}</span>
				</div>
			);
		}
		else if (usr.chat_locking == 1) {
			actions.push(
				<button key='e' type="button" className="dropdown-item" onClick={this.onLockUser.bind(this, usr, 0)}>
					<em className="la la-unlock" />
					<span>{__('socials_do_unlock')}</span>
				</button>
			);
		}
		else {
			actions.push(
				<button key='e' type="button" className="dropdown-item" onClick={this.onLockUser.bind(this, usr, 1)}>
					<em className="la la-lock" />
					<span>{__('socials_do_lock')}</span>
				</button>
			);
		}
		return (
			<div className="actions dropdown float-right">
				<button className="btn btn-link btn-circular" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-display="static">
					<em className="la la-ellipsis-v" />
				</button>
				<div className="dropdown-menu">
					{actions}
				</div>
			</div>
		);
	}


	render() {
		if (!hp.store.chat) {
			return null;
		}
		const {chat} = hp.store;
		const active = this.state.active ? user.get(this.state.active) : null;
		const selected_user = active
			?	<div className="d-flex bd-highlight active">
					<div className={classNames(this.props.mobile ? null : "btn-group d-block d-sm-none")}>
						<button className="btn" onClick={() => this.setState({active: null})}>
							<em className="la la-arrow-left"/>
						</button>
					</div>
					{active.profile.logo ? <img className="avatar" src={active.profile.logo} alt="" /> : this.avatar}
					<div className="user-info">
						{active.profile.name}
					</div>
				</div>
			: 	<div className="d-flex bd-highlight">
					<em className="la la-info-circle" />
					<span className="alert-none">{__('socials_chat_selected_none')}</span>
				</div>;
		let messages = null, editor = null;
		let users = Object.keys(chat.users);

		users = users.map(uid => {
			const usr = chat.users[uid];
			const unreads = <span className="badge badge-primary badge-pill">{chat.unread[uid] ? chat.unread[uid] : null}</span>
			const locked = usr.chat_locking == 1 || usr.chat_locked == 1;
			/*
			const locked = usr.locked
				? <em className="r la la-lock danger" title="clique aqui para desbloquear este sócio" onClick={this.onLockUser.bind(this, usr, 0)} />
				: <em className="r la la-unlock" title="clique aqui para bloquear este sócio" onClick={this.onLockUser.bind(this, usr, 1)} />
			*/
			return (
				<li key={uid} className={active && uid === active.uid ? "active" : null}>
					<Link key={uid} to={'/home/chat/' + uid}>
						<div className="d-flex bd-highlight">
							{usr.logo ? <img className="avatar" src={usr.logo} alt="" /> : this.avatar}
							<div className={classNames("user-info", chat.unread[uid] ? 'font-weight-bold' : null, locked ? 'danger' : null)}>
								{usr.name}
							</div>
							<div className="r">
								{unreads}
								{this.renderUserActions(usr)}
							</div>
						</div>
						{usr.typing && active && usr.id !== active.uid ? <div className="ml-2"><div className="typing-loader" /></div> : null}
					</Link>
				</li>
			)
		});
		if (active) {
			const user_msgs = chat.data[active.uid] || {};
			const chat_usr = chat.users[active.uid];
			const avatar =
				<div className="avatar">
					{chat_usr.logo ? <img src={chat_usr.logo} alt="" /> : this.avatar}
				</div>
			let my_last_msg = null;

			messages = Object.keys(user_msgs);
			for (let i = messages.length - 1; i >= 0; i --) {
				if (user_msgs[messages[i]].mine == 1) {
					my_last_msg = user_msgs[messages[i]];
					break;
				}
			}
			messages = messages.map(id => {
				const msg = user_msgs[id];
				const when =
					<span className="time">
						{format(msg.updated_at, isToday(msg.updated_at) ? this.formatToday : 'dd MMM yyyy H:s', hp.settings.current_locale)}
					</span>
				const comment =
					<div className={classNames(msg.read == 1 ? null : 'font-weight-bold')}>
						<span dangerouslySetInnerHTML={{__html: msg.comment}} />
					</div>
				//const when = <span className="time">{formatDistanceToNowStrict(msg.updated_at, {locale: locates[hp.settings.locale]})}</span>

				return (msg.mine
					?	<div key={id} className="d-flex mb-4 comment justify-content-end">
							<div className="text mine">
								{comment}
								{when}
							</div>
							{msg === my_last_msg ? <em className="la la-pencil pointer" onClick={this.onCommentEdit.bind(this, msg, false)} /> : null}
							{this.my_avatar}
						</div>
					:	<div key={id} className="d-flex mb-4 comment justify-content-start">
							{avatar}
							<div className="text">
								{comment}
								{when}
							</div>
						</div>
				)
			});
			editor = chat_usr.chat_locking == 1 || chat_usr.chat_locked == 1
				? null
				: <Editor model={this.state.msg} name="comment"
					onInput={this.onInput.bind(this)}
					onSend={this.onSend.bind(this)}
					onSelect={this.onCommentEdit.bind(this, my_last_msg)}
				/>;
		}
		const mobile_cls = this.props.mobile ? [null, null, "d-none"] : ["col-sm-4", "col-sm-8", "d-none d-sm-block"];

		return (
			<div className="row justify-content-center no-gutters chat card-group">
				<div className={classNames("card users col-xs-12", mobile_cls[0], this.state.active ? mobile_cls[2] : null)}>
					<div className="card-header">
						<Select placeholder={__('socials_chat_search')}
							url="/home/searchUser.json"
							onChange={this.onUserFound.bind(this)}
						/>
					</div>
					<ul className="contacts">
						{users}
					</ul>
				</div>
				<div className={classNames("card msg col-xs-12", mobile_cls[1], this.state.active ? null : mobile_cls[2])}>
					<div className="card-header">
						{selected_user}
					</div>
					<div className="card-body" ref={this.messages}>
						<div className="body">
							{messages}
							{active && active.profile.typing ? <div className="typing-loader" /> : null}
						</div>
					</div>
					<div className="card-footer">
						{editor}
					</div>
				</div>
			</div>
		)
	}
}
